import PropTypes from 'prop-types';
import ReactCountryFlag from "react-country-flag";
import Tooltip from '@material-ui/core/Tooltip';

/**
 * Renders the content for the AIS target popup.
 * @param {object} props - Component props.
 * @param {object} props.data - The AIS target data object.
 */
const AisPopupContent = ({ data }) => {
  if (!data) {
    return <div>No AIS data available.</div>; // Handle cases where data might be missing
  }

  return (
    <div>
      <p>
        Mmsi: <b>
          <a
    //        href={`https://www.marinetraffic.com/en/ais/details/ships/shipid:${data.mmsi}`}
            href={`https://www.marinetraffic.com`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data.mmsi || 'n/a'}
          </a>
        </b>
      </p>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          <tr>
            <td style={{ fontWeight: 'bold', paddingRight: 8, verticalAlign: 'top' }}>Name:</td>
            <td>{data.name || 'n/a'}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', paddingRight: 8, verticalAlign: 'top' }}>Type:</td>
            <td>{data.vesselType || 'n/a'}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', paddingRight: 8, verticalAlign: 'top' }}>Country:</td>
            <td>
              <Tooltip title={data.country || 'N/A'}>
                <ReactCountryFlag countryCode={data.countryCode} svg />
              </Tooltip>
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', paddingRight: 8, verticalAlign: 'top' }}>COG:</td>
            <td>{data.cog !== undefined ? data.cog : 'n/a'}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', paddingRight: 8, verticalAlign: 'top' }}>HDG:</td>
            <td>{data.hdg !== undefined ? data.hdg : 'n/a'}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: 'bold', paddingRight: 8, verticalAlign: 'top' }}>SOG:</td>
            <td>{data.sog !== undefined ? data.sog : 'n/a'}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

AisPopupContent.propTypes = {
  data: PropTypes.shape({
    mmsi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    vesselType: PropTypes.string,
    country: PropTypes.string,
    // cog: PropTypes.number,
    // sog: PropTypes.number,
  }),
};

export default AisPopupContent; // Export if in its own file, otherwise keep it within Ais.js
